export default __webpack_public_path__ + "static/media/deleted.06db0a68.png";